import clsx from 'clsx'
import { getThemeClassName } from 'lib/theme/themeUtils'
import type { PropsWithChildren } from 'react'
import { forwardRef } from 'react'
import type { RequireAtLeastOne } from 'type-fest'

type Props = PropsWithChildren<{
  className?: string
} & RequireAtLeastOne<{
  paletteType?: App.Design.PaletteType
  tabletPaletteType?: App.Design.PaletteType
  desktopPaletteType?: App.Design.PaletteType
}, 'paletteType' | 'tabletPaletteType' | 'desktopPaletteType'>>

const PaletteSheet = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const {
    children,
    className,
    paletteType,
    tabletPaletteType,
    desktopPaletteType,
  } = props

  return <div
    ref={ref}
    className={clsx(className, getThemeClassName({ mobile: paletteType, tablet: tabletPaletteType, desktop: desktopPaletteType }))}
  >
    {children}
  </div>
})

export default PaletteSheet
